// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"3b53517f","968":"d1a727b0","3518":"3b53517f","9219":"3b53517f","9585":"3b53517f"}[chunkId] + ".chunk.css";
};